var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Dialog } from "@wayfarer/components";
export function SafeDialog(props) {
    useEffect(function () {
        if (!props.open)
            return;
        // Small delay to ensure DOM is updated
        var timer = setTimeout(function () {
            // Combined selector using OR (||) logic with comma-separated selectors
            var elementsToFix = document.querySelectorAll("\n        .wyfr-modal___layer,\n        [aria-modal=\"true\"],\n        [tabindex=\"-1\"][aria-modal=\"true\"],\n        [class*=\"wyfr-modal___layer\"],\n        [role=\"dialog\"]\n      ");
            elementsToFix.forEach(function (element) {
                if (element.hasAttribute('tabindex')) {
                    element.removeAttribute('tabindex');
                }
            });
        }, 100);
        return function () { return clearTimeout(timer); };
    }, [props.open]); // Re-run when dialog opens/closes
    return _jsx(Dialog, __assign({}, props));
}
